module.exports = __webpack_public_path__ + "img/51626509_L.a51e78a9.png";